// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3Mw94","title":"ClientReferral_title__hNn3H","itemText":"ClientReferral_itemText__1-ue1"};